import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import { isString } from 'common';
import { ReactNode } from 'react';
import { CfDataGridDisplayMode } from '../../CfDataGridProps';
import { StyledBox, StyledTypography } from './CfDataGridNoResultsFound.styles';

export interface CfDataGridNoResultsFoundProps {
  message?: ReactNode;
  displayMode: CfDataGridDisplayMode;
  sx?: SxProps<Theme>;
}

export const CfDataGridNoResultsFound = (props: CfDataGridNoResultsFoundProps): JSX.Element => {
  const displayModeSx =
    props.displayMode === 'table'
      ? { mt: 2 }
      : {
          width: '100%',
          mt: 2,
          py: 2,
          borderRadius: 1,
          backgroundColor: (theme: Theme) => theme.palette.common.white,
        };

  if (!props.message) return <></>;

  return (
    <StyledBox
      sx={{
        ...displayModeSx,
        ...props.sx,
      }}
    >
      {isString(props.message) ? (
        <StyledTypography>{props.message ? props.message : 'No items found'}</StyledTypography>
      ) : (
        <>{props.message}</>
      )}
    </StyledBox>
  );
};
